import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "IV. Allergies アレルギー", -1)
const _hoisted_3 = { class: "grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_4 = { class: "col-span-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Do you have any allergies? アレルギーはありますか：", -1)
const _hoisted_6 = { class: "grid grid-cols-1 space-y-2 lg:grid-cols-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "col-span-6 mt-3 space-y-3 pl-7"
}

import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllergiesInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const item = ref(props.form)

watch(
    () => item.value.has_allergies,
    (val: boolean) => {
        if (val == false) {
            item.value.medication = null;
            item.value.food = null;
            item.value.specify_other = null;
        }
    }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(RadioGroup, {
            options: [
                            { id: 'no', label: 'No/いいえ', value: 'no'},
                            { id: 'yes', label: 'Yes/はい', value: 'yes'},
                        ],
            name: "has_allergies",
            customClass: "col-span-6",
            disabled: __props.disableInputs,
            modelValue: item.value.has_allergies,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.has_allergies) = $event))
          }, null, 8, ["disabled", "modelValue"]),
          _hoisted_7,
          (item.value.has_allergies)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(TextInput, {
                  id: "medication",
                  type: "text",
                  placeholder: "Medication/薬",
                  disabled: __props.disableInputs,
                  modelValue: item.value.medication,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.medication) = $event))
                }, null, 8, ["disabled", "modelValue"]),
                _createVNode(TextInput, {
                  id: "food",
                  type: "text",
                  placeholder: "Food/食べ物",
                  disabled: __props.disableInputs,
                  modelValue: item.value.food,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.food) = $event))
                }, null, 8, ["disabled", "modelValue"]),
                _createVNode(TextInput, {
                  id: "specify_other",
                  type: "text",
                  placeholder: "Other/その他",
                  disabled: __props.disableInputs,
                  modelValue: item.value.specify_other,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.specify_other) = $event))
                }, null, 8, ["disabled", "modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})